import { CLOSE_FRAME } from './config.js';

const BTN = document.getElementById( 'IF-CLOSE' );

function postClose( href = '' ){
  try { window.parent.postMessage( { type: CLOSE_FRAME , href } , window.location.origin ); } catch ( _ ) { }
}

function doClose( href = '' ){
  postClose( href );
  try { window.history.back( ); } catch ( _ ) { }
}

function onDocumentClick( ev ){
  const a = ev.target.closest( 'a[href]' );
  if ( !a ) return;

  // respeta gestos de nueva pestaña/ventana
  if ( ev.defaultPrevented ) return;
  if ( ev.button !== 0 ) return;
  if ( ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey ) return;

  const href = a.getAttribute( 'href' ) || '';
  if ( !href ) return;

  ev.preventDefault( );
  doClose( href );
}

function initClose( ){
  if ( BTN ){
    BTN.addEventListener( 'click' , function ( e ){ e.preventDefault( ); doClose( ); } , false );
    document.addEventListener( 'click' , onDocumentClick , false );
  }

}

export { initClose };
